export enum Period {
  LastYear = "last-year",
  LastMonth = "last-month",
  LastWeek = "last-week",
}
